import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

var Pricing = function Pricing(_ref) {
  var freePlan = _ref.freePlan,
      premiumPlan = _ref.premiumPlan,
      apiUrl = _ref.apiUrl;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  return /*#__PURE__*/_jsx("section", {
    className: "py-8 mx-auto border-b max-w-7xl ",
    id: "pricing",
    children: /*#__PURE__*/_jsxs("div", {
      className: "container px-2 pt-4 pb-12 mx-auto text-gray-800",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "w-full my-2 text-5xl font-black leading-tight text-center text-gray-800",
        children: t('landing.navigations.pricing')
      }), /*#__PURE__*/_jsx("div", {
        className: "w-full mb-2",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-64 h-1 py-0 mx-auto my-0 rounded-t opacity-25 gradient"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-2 text-center",
        children: /*#__PURE__*/_jsx("h3", {
          className: "text-2xl font-black text-gray-600",
          children: t('landing.subscribeToPlanSubTitle')
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col space-y-4 justify-evenly lg:my-12 md:flex-row sm:my-4 md:space-x-4 md:space-y-2 ",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-col w-full mx-auto mt-4 bg-white rounded-none lg:rounded-l-lg",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-1 overflow-hidden text-gray-600 bg-white rounded-t rounded-b-none shadow",
            children: [/*#__PURE__*/_jsx("div", {
              className: "p-8 text-3xl font-bold text-center border-b-4",
              children: t('landing.FreePlan')
            }), /*#__PURE__*/_jsx("ul", {
              className: "w-full px-4 text-sm md:text-base",
              children: freePlan === null || freePlan === void 0 ? void 0 : freePlan.map(function (feature, index) {
                return /*#__PURE__*/_jsxs("li", {
                  className: "flex items-start py-4 ml-2",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/_jsx(CheckIcon, {
                      className: "flex-shrink-0 w-6 h-6 text-green-500",
                      "aria-hidden": "true"
                    })
                  }), /*#__PURE__*/_jsx("p", {
                    className: "ml-3",
                    children: feature.forfait
                  })]
                }, index);
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-none p-6 mt-auto overflow-hidden bg-white rounded-t-none rounded-b shadow",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "w-full pt-6 text-3xl font-bold text-center text-gray-600",
              children: [i18n.language === 'en' ? '$0' : '0€', ' ', /*#__PURE__*/_jsxs("span", {
                className: "text-base",
                children: ["/", t('landing.byMonth')]
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "flex items-center justify-center",
              children: /*#__PURE__*/_jsx(Link, {
                href: "".concat(apiUrl, "/auth/register"),
                "aria-describedby": "tier-growth",
                children: /*#__PURE__*/_jsx("a", {
                  className: "px-8 py-4 mx-auto my-6 font-semibold text-white rounded-md shadow-lg gradient2 lg:mx-0 hover:no-underline",
                  children: t('landing.getFreeStarted')
                })
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col w-full mx-auto mt-4 bg-white rounded-none lg:rounded-l-lg",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-1 overflow-hidden text-gray-600 bg-white rounded-t rounded-b-none shadow",
            children: [/*#__PURE__*/_jsx("div", {
              className: "p-8 text-3xl font-bold text-center border-b-4",
              children: t('landing.proPlan')
            }), /*#__PURE__*/_jsx("ul", {
              className: "w-full px-4 text-sm md:text-base",
              children: premiumPlan === null || premiumPlan === void 0 ? void 0 : premiumPlan.map(function (feature, index) {
                return /*#__PURE__*/_jsxs("li", {
                  className: "flex items-start py-4 ml-2",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/_jsx(CheckIcon, {
                      className: "flex-shrink-0 w-6 h-6 text-green-500",
                      "aria-hidden": "true"
                    })
                  }), /*#__PURE__*/_jsx("p", {
                    className: "ml-3",
                    children: feature.forfait
                  })]
                }, index);
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-none p-6 mt-auto overflow-hidden bg-white rounded-t-none rounded-b shadow",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "w-full pt-6 text-3xl font-bold text-center text-gray-600",
              children: [i18n.language === 'en' ? '$9.99' : '9.99€', /*#__PURE__*/_jsxs("span", {
                className: "text-base",
                children: ["/", t('landing.byMonth')]
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "flex items-center justify-center",
              children: /*#__PURE__*/_jsx(Link, {
                href: "".concat(apiUrl, "/auth/register"),
                "aria-describedby": "tier-growth",
                children: /*#__PURE__*/_jsx("a", {
                  className: "px-8 py-4 mx-auto my-6 font-semibold text-white rounded-md shadow-lg gradient2 lg:mx-0 hover:no-underline",
                  children: t('landing.getProtarted')
                })
              })
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-20",
        children: /*#__PURE__*/_jsxs("p", {
          className: "max-w-4xl mx-auto mt-3 mb-4 text-lg text-gray-500 sm:mt-5 sm:text-xl",
          children: [t('landing.subscribeToPlanDescription'), /*#__PURE__*/_jsx("span", {
            className: "text-indigo-300 cursor-pointer hover:text-indigo-400",
            children: /*#__PURE__*/_jsx(Link, {
              href: "".concat(apiUrl, "/auth/register"),
              "aria-describedby": "tier-growth",
              children: t('landing.rejoignezNous')
            })
          }), t('landing.rejoignezNousSubTitle')]
        })
      })]
    })
  });
};

export default Pricing;